import {cva} from 'class-variance-authority';

export const itemVariants = cva(
  'group/item rounded-soft outline-none transition-colors duration-100 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
  {
    variants: {
      variant: {
        subtle: 'bg-neutral-50',
        muted: 'bg-muted',
        surface: 'bg-surface-modal',
      },
      size: {
        default: 'px-4 py-3',
        loose: 'p-4',
        compact: 'px-3 py-1.5',
        tight: 'p-2',
      },
    },
    defaultVariants: {
      variant: 'subtle',
      size: 'default',
    },
  }
);

export const itemMediaVariants = cva(
  'flex shrink-0 items-center justify-center gap-2 [&_svg]:pointer-events-none',
  {
    variants: {
      variant: {
        default: 'bg-transparent',
        circle:
          "size-8 rounded-full bg-surface-card [&_svg:not([class*='size-'])]:size-4",
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);
